import People from "@/pages/crm/People";
// Administration → People reuses the same shared Atlas People capability.
export default function AdminPeople() {
  return <People />;
}
